import {useEffect} from 'react'

const DEFAULT_POINT_ZOOM = 14

export const useSearch = ({isLoaded, mapInstance, searchInputRef}) => {
	useEffect(() => {
		const inputElement = searchInputRef.current
		const {google} = window || {}
		if (!isLoaded || !google || !mapInstance || !inputElement) return

		const autocomplete = new google.maps.places.Autocomplete(inputElement, {
			fields: ['geometry'],
		})
		autocomplete.bindTo('bounds', mapInstance)

		const listener = autocomplete.addListener('place_changed', () => {
			const place = autocomplete.getPlace()

			const viewport = place?.geometry?.viewport
			const location = place?.geometry?.location

			if (!viewport && !location) return

			if (viewport) {
				mapInstance.fitBounds(viewport)
			} else {
				mapInstance.panTo({lat: location.lat(), lng: location.lng()})
				mapInstance.setZoom(DEFAULT_POINT_ZOOM)
			}
		})

		return () => {
			listener.remove()
			autocomplete.unbind()
		}
	}, [isLoaded, mapInstance, searchInputRef])
}
